import React from 'react';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

class HtmlToPdf extends React.Component {

    generatePDF = () => {
        const input = document.getElementById('my-html-template');
        html2canvas(input)
            .then((canvas) => {
                const imgData = canvas.toDataURL('image/png');
                const pdf = new jsPDF(
                    // {
                    //     orientation: "landscape",
                    //     unit: "in",
                    //     // format: [4, 2]
                    // }
                );

                pdf.addImage(imgData, 'PNG', 5, 5);
                pdf.setDisplayMode('fullwidth', 'continuous');

                pdf.save('myPDF.pdf');
            });
    }

    render() {
        return (
            <>
                <div id="my-html-template" className='border px-8'>
                    <center><b>CLASSIFIED</b></center>
                    <center style={{ marginTop: '10px' }}>GLENDALE UNIFIED SCHOOL DISTRICT
                        <div>Glendale, California</div>
                        <div style={{ marginTop: '20px' }}><b>ADVANCE REQUEST FOR CLASSIFIED SUBSTITUTE</b></div>

                        <div className='border w-2/4 text-[12px] mt-4'>
                            DIRECTIONS:This form is to be completed and routed according to the approval signature(s) sequence below when requesting a Classified Substitute.
                        </div>
                    </center>
                    <div className='mt-8'>

                        <div className='leading-10'>
                            <div className='flex justify-between'>
                                <p>CLASSIFICATION ______</p> <p>DATES From: ______ Thru: ______</p></div>
                            <p>Type of Sub Request/Object Code:</p>
                            <p>Absent Employee's Legal Name (if applicable) ____________________</p>

                            <div className='flex justify-between'>
                                <p>Total Working Hours _______________</p>
                                <p>From __________ To _______________</p>
                            </div>
                            <p>Location ________________________________________________________________________</p>
                            <p>Reason For Absence/Request ________________________________________________________________________</p>
                            <p>If possible, we would like to have ________________________________________________________________________</p>
                        </div>

                        <div className='mt-8 w-2/4 border'>
                            <div className='font-bold text-center'>Account Number(s) To Be Charged</div>
                            <p>________________________________________________________________________</p>
                            <p>________________________________________________________________________</p>
                            <p>________________________________________________________________________</p>
                            <p>________________________________________________________________________</p>
                        </div>



                        {/* ---------------------------------------------------------------------------------------------------------------- */}
                        {/* <p className='mt-2.5 leading-10'>
                            Its requested that approval be granted to assign, on a voluntary basis, <span className='w-16 mx-8 text-[green] font-medium'>{this.props.data?.employeeName}</span> EID# <span className='w-16 mx-8 text-[green] font-medium'>{this.props.data.employeeId}</span>, teacher, to a sixth period teaching assignment at <span className='w-16 mx-8 text-[green] font-medium'>{this.props.data?.schoolName}</span> for the period from <span className='w-16 mx-8 text-[green] font-medium'>{this.props.data?.dateFrom}</span> to <span className='w-16 mx-8 text-[green] font-medium'>{this.props.data.dateTo}</span>.
                        </p>
                        <p className='mt-2.5 leading-10'>
                            Subject Area Added: <span className='w-16 mx-8 text-[green] font-medium'>{this.props.data?.subjectName}</span> Total Staffing Allocation: <span className='w-16 mx-8 text-[green] font-medium'>{this.props.data?.staffAllocation}</span>
                            Account Charged: <span className='w-16 mx-8 text-[green] font-medium'>{this.props.data?.accountCharged}</span> Current FTE Utilized: <span className='w-16 mx-8 text-[green] font-medium'>{this.props.data?.fteUtilized}</span>
                        </p> */}

                        {/* <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '40px', marginRight: '10px' }}>
                                <div>_________________ <br />
                                    <p style={{ fontSize: '10px' }}>Principal Signature </p>
                                </div>
                                <div style={{ marginLeft: '20px' }}> ____________________<br />
                                    <p style={{ fontSize: '10px' }}>Date</p>
                                </div>
                            </div> */}
                        {/* <div className='mt-2.5 border-b-4 border-[black]'></div>


                        <p className='mt-2.5 leading-10'>
                            I accept, on voluntary basis, a sixth period teaching assignment at <span className='w-16 mx-8 text-[green] font-medium'>{this.props.data?.schoolName}</span> for the period from <span className='w-16 mx-8 text-[green] font-medium'>{this.props.data?.dateFrom}</span> to <span className='w-16 mx-8 text-[green] font-medium'>{this.props.data?.dateTo}</span>
                        </p>
                        <p className='mt-2.5 leading-10'>
                            I understand and accept this assignment under the following provisions:

                        </p>
                        <ul 
                        className='list-decimal mt-2.5 leading-10 pl-20'
                        >
                            <li>Payment for t he sixth period teaching assignment shall be at my hourly rate of pay,determined by dividing my daily rate of pay by five (5).</li>
                            <li>The sixth period teaching assignment will ot interfere with my regularly assigned duties.</li>
                            <li>The sixth period teaching assignment replaces my normal preparation/conference period,which will then be scheduled immediately preceding or concluding the normal worksite day.</li>
                            <li>This assignment i contingent on funding and enrollment.</li>
                        </ul> */}

                    </div>
                </div>

                <button className='bg-[#113699] border mt-10 border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium text-[#fff] flex items-center py-[10px] px-[8px] rounded-[8px] justify-center' onClick={this.generatePDF}>Generate PDF</button>
            </>
        );
    }
}

export default HtmlToPdf;